package com.jingfangpai.common.data.model

import com.jingfangpai.common.constant.Error;
import com.jingfangpai.common.utils.ExceptionUtils
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 * 接口或方法的执行结果
 */
@Serializable
open class Result() {
    constructor(error:Error,message:String):this(){
        this.error = error
        this.message = message
    }
    var error: Error = Error.NA/**错误信息，无错误返回NA*/
    var message: String? = null/**附加消息，一般为异常消息*/
    fun setException(ex: Exception) {
        if (ex is com.jingfangpai.common.exception.SystemException && (ex as com.jingfangpai.common.exception.SystemException).getError() != null) {
            error = (ex as com.jingfangpai.common.exception.SystemException).getError()
        } else {
            error = Error.操作失败
        }
        if (ex is NullPointerException) {
            message = "抱歉,执行因NPE错误异常终止"
        } else {
            val rootCause: Throwable = ExceptionUtils.getRootCause(ex)
            if (rootCause != null) {
                message = rootCause.message
            } else {
                message = ex.message
            }
        }
    }

    fun hasError(): Boolean {
        return error !== Error.NA
    }
    fun ok(): Boolean {
        return error == Error.NA
    }
}
